import type { Premiere } from "@filmweb/sanity-types";
import { locale as locl } from "@locale";
import { format, parse, parseISO } from "date-fns";
import { locale } from "src/lib/locale/date-fns";

type PremiereValue = {
	premiereLabel: string;
	premiere: string;
}

export default function premiereValue(premiere?: Premiere | null, customPremiereLabel?: string): PremiereValue | null {
	if (!premiere) {
		return null;
	}

	let premLabel = "";
	let prem: string | null = null;
	const premDate = premiere!.reReleaseDate ?? premiere!.premiereDate;
	if (premDate) {
		premLabel = locl.filmomtale.premiere;
		if (premiere!.reReleaseDate) {
			premLabel = locl.filmomtale.reRelease;
		}
		const d = parse(premDate, "yyyy-MM-dd", new Date());
		prem = format(d, "dd.MM.yyyy", { locale });
	} else if (premiere?.expectedPremiereDate) {
		premLabel = locl.filmomtale.expectedPremeiere;
		const d = parse(premiere!.expectedPremiereDate, "yyyy-MM-dd", new Date());
		prem = format(d, "MMMM yyyy", { locale });
	}

	if (!prem) {
		return null;
	}

	premLabel = customPremiereLabel ?? premLabel;

	return {
		premiere: prem,
		premiereLabel: premLabel
	}
}

export function formatPremiereValueFromMovieInfo(premiere: string | null | undefined) {
	if (!premiere) {
		return null;
	}

	const parsedPrem = parseISO(premiere);
	return format(parsedPrem, "dd.MM.yyyy", { locale });
}